import { useMutation } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const initiatePayment = async (orderId, token) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/payment/payments/initiate/${orderId}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const useRetryMarketplacePayment = () => {
  const { token } = useContext(AuthContext);

  return useMutation(({ orderId }) => initiatePayment(orderId, token));
};

export default useRetryMarketplacePayment;
